// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"267":"pages/tournament","455":"pages/odins-journal","662":"pages/settings","911":"pages/crew-battle","925":"pages/odins-journal-config","964":"pages/admin"}[chunkId] || chunkId) + ".bundle.js";
};